<template>
  <a-spin class="baseSet" :spinning="baseSetLoading">
    <!-- <h1>基本设置</h1> -->
    <a-card class="card" title="基本设置" :class="$store.getters['course/getSeriesInfo']().status === 1 && 'no-click'">
      <a-form-model :model="form.data" :rules="formRules" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }" labelAlign="right" ref="formCourse">
        <div class="self-item">
          <div class="self-item-left">
            <a-form-model-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }" label="图标" prop="icon">
              <a-upload name="imgFile" list-type="picture-card" :show-upload-list="false" :headers="headers" :action="baseURL" @change="changeIcon" :before-upload="beforeIcon">
                <div v-if="form.data.icon">
                  <a-icon v-show="imgLoading" style="position: absolute; top: 45%; left: 45%" type="loading" />
                  <img style="width: 240px; height: 240px" :src="form.data.icon | filterUrl" alt="avatar" />
                </div>
                <div style="color: #bbb" v-else>
                  <a-icon style="font-size: 30px" :type="iconloading ? 'loading' : 'plus'" />
                  <p>上传</p>
                </div>
              </a-upload>
              <p style="color: #bbb">建议上传 280 * 280 尺寸的图片</p>
            </a-form-model-item>
          </div>
          <div class="self-item-right">
            <a-form-model-item label="课程名称" prop="name">
              <a-input v-model="form.data.name" :maxLength="15" placeholder="不超过15个字符">
                <span class="input-number" slot="suffix"> {{ form.data.name ? form.data.name.length : 0 }} / 15 </span>
              </a-input>
            </a-form-model-item>
            <a-form-model-item prop="courseType">
              <span slot="label">
                课程类型&nbsp;
                <a-tooltip>
                  <template slot="title"> 训练课程可添加训练课时，测评课程下仅可添加测评课时 </template>
                  <a-icon style="cursor: pointer" type="question-circle" />
                </a-tooltip>
              </span>
              <!--                            课程类型编辑是修改会导致机构课程 的课程类型错乱-->
              <a-radio-group v-model="form.data.courseType" :disabled="!!form.data.id">
                <a-radio :value="1">测评课程</a-radio>
                <a-radio :value="2">训练课程</a-radio>
                <a-radio :value="3">活动课程</a-radio>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="售卖价格" prop="price">
              <a-input-number v-model="form.data.price" :min="0" :max="9999" placeholder="仅可输入9999以内数字" />
            </a-form-model-item>
            <a-form-model-item label="适用学段" prop="period">
              <a-select placeholder="请选择学段" v-model="form.data.period">
                <a-select-option :value="item" v-for="item in $data._period" :key="item.id">{{ item }}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item>
              <span slot="label" class="ant-form-item-required">适用年龄</span>
              <div class="age">
                <a-form-model-item :wrapper-col="{ span: 24 }" prop="minAge">
                  <a-input-number v-model="form.data.minAge" :min="0" style="width: 100%" :max="99" placeholder="输入0 - 99的数字" />
                </a-form-model-item>
                <span style="margin: 0 20px">-</span>
                <a-form-model-item :wrapper-col="{ span: 24 }" prop="maxAge">
                  <a-input-number v-model="form.data.maxAge" :min="0" style="width: 100%" :max="99" placeholder="输入0 - 99的数字" />
                </a-form-model-item>
              </div>
            </a-form-model-item>
            <a-form-model-item label="能力类型" prop="suitAbilityType" v-if="form.data.courseType === 2">
              <a-select class="serach-item" style="width: 431px" allowClear v-model="form.data.suitAbilityType" placeholder="请选择能力类型">
                <a-select-option value="不均衡型">不均衡型</a-select-option>
                <a-select-option value="亟待提升">亟待提升</a-select-option>
                <a-select-option value="全面突出">全面突出</a-select-option>
                <a-select-option value="平衡发展">平衡发展</a-select-option>
                <a-select-option value="有待改进">有待改进</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="能力标签" :prop="form.data.courseType != 3 ? 'courseAbilityList' : ''" class="courseAbilityList">
              <InputLabel v-model="form.data.courseAbilityList" :options="abilitySelect"></InputLabel>
            </a-form-model-item>
          </div>
        </div>
        <div class="form-like">
          <a-form-model-item label="喜欢人数" :wrapperCol="{ span: 20 }">
            <a-input-number v-model="form.data.baseLikeCount" :precision="0" :min="0" :max="999999999" placeholder="输入增加量" />
          </a-form-model-item>
          <a-form-model-item label="在学人数" :wrapperCol="{ span: 20 }">
            <a-input-number v-model="form.data.baseStudyCount" :precision="0" :min="0" :max="999999999" placeholder="输入增加量" />
          </a-form-model-item>
        </div>
        <a-form-model-item
          :class="form.data.capabilityWeight ? 'weight flex' : ' weight'"
          v-if="form.data.courseType == 2"
          label="能力权重"
          :label-col="{ span: 3 }"
          :wrapperCol="{ span: 21 }"
          prop="capabilityWeight"
        >
          <a-switch v-model="form.data.capabilityWeight" />
          <ul class="inputs" v-if="form.data.capabilityWeight" style="list-style: none; padding-left: 0">
            <li>
              <div class="list">
                <span>{{ weightStr.attentionAbility && weightStr.attentionAbility.name }}</span>
                <a-input-number @blur="capabilityWeightBlur" v-model="inputs.num1" :min="0" :precision="3" placeholder="仅可输入非负数" />
              </div>
              <p v-if="inputsCheck[0]">请输入{{ weightStr.attentionAbility && weightStr.attentionAbility.name }}权重</p>
            </li>
            <li>
              <div class="list">
                <span>{{ weightStr.memoryAbility && weightStr.memoryAbility.name }}</span>
                <a-input-number @blur="capabilityWeightBlur" v-model="inputs.num2" :min="0" :precision="3" placeholder="仅可输入非负数" />
              </div>
              <p v-if="inputsCheck[1]">请输入{{ weightStr.memoryAbility && weightStr.memoryAbility.name }}权重</p>
            </li>
            <li>
              <div class="list">
                <span>{{ weightStr.reactionAbility && weightStr.reactionAbility.name }}</span>
                <a-input-number @blur="capabilityWeightBlur" v-model="inputs.num3" :min="0" :precision="3" placeholder="仅可输入非负数" />
              </div>
              <p v-if="inputsCheck[2]">请输入{{ weightStr.reactionAbility && weightStr.reactionAbility.name }}权重</p>
            </li>
            <li>
              <div class="list">
                <span>{{ weightStr.selfAbility && weightStr.selfAbility.name }}</span>
                <a-input-number @blur="capabilityWeightBlur" v-model="inputs.num4" :min="0" :precision="3" placeholder="仅可输入非负数" />
              </div>
              <p v-if="inputsCheck[3]">请输入{{ weightStr.selfAbility && weightStr.selfAbility.name }}权重</p>
            </li>
            <li>
              <div class="list">
                <span>{{ weightStr.thinkingAbility && weightStr.thinkingAbility.name }}</span>
                <a-input-number @blur="capabilityWeightBlur" v-model="inputs.num5" :min="0" :precision="3" placeholder="仅可输入非负数" />
              </div>
              <p v-if="inputsCheck[4]">请输入{{ weightStr.thinkingAbility && weightStr.thinkingAbility.name }}权重</p>
            </li>
          </ul>
        </a-form-model-item>
        <a-form-model-item label="备注" :label-col="{ span: 3 }" :wrapperCol="{ span: 17 }">
          <div id="remarkEditor"></div>
        </a-form-model-item>
        <a-form-model-item label="简介" :label-col="{ span: 3 }" :wrapperCol="{ span: 17 }">
          <div style="position: relative">
            <a-input v-model="form.data.description" class="input-textarea" type="textarea" :maxLength="100" placeholder="不超过100个字符" :auto-size="{ minRows: 3 }" />
            <span class="input-textarea-number"> {{ form.data.description ? form.data.description.length : 0 }} / 100 </span>
          </div>
        </a-form-model-item>
        <a-form-model-item label="课程介绍" :label-col="{ span: 3 }" :wrapperCol="{ span: 17 }">
          <div id="nameEditor"></div>
        </a-form-model-item>
      </a-form-model>
    </a-card>
    <footer-tool-bar v-if="$store.getters['course/getSeriesInfo']().status !== 1">
      <a-button type="primary" @click="onSubmitAll" :loading="subLoading">保存信息</a-button>
    </footer-tool-bar>
  </a-spin>
</template>

<script>
import Apis from '@/requests/apis'
import FooterToolBar from '@/components/tool/FooterToolBar'
import InputLabel from '@/components/InputLabel'

function getBase64(img, callback) {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}

import E from 'wangeditor'

export default {
  name: 'baseSet',
  components: { FooterToolBar, InputLabel },
  data() {
    return {
      // icon
      iconloading: false,
      imgLoading: false,
      baseURL: process.env.VUE_APP_API_BASE_URL + Apis.File.upload + '?filePath=content/course',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
      nameEditor: null, //富文本编辑器
      remarkEditor: null, //富文本编辑器
      abilitySelect: [],
      subLoading: false,

      baseSetLoading: false,
      courseInfo: {},
      seriesInfo: this.$store.getters['course/getSeriesInfo']() || {},
      form: {
        data: {
          normTag: undefined,
          id: undefined, // 课程id
          name: '',
          courseSeriesId: undefined, // 系列id
          courseType: undefined,
          period: undefined, // 学段
          minAge: undefined,
          maxAge: undefined,
          price: undefined, // 价格
          icon: 'https://cdn.iquizoo.com/content/course/课程默认封面.png',
          remark: '', // 备注
          description: '', // 描述
          capabilityWeight: false, //能力权重
          introduce: undefined, // 介绍
          courseAbilityList: [],
          baseLikeCount: undefined,
          baseStudyCount: undefined,
          suitAbilityType: undefined,
        },
        check: false,
      },
      inputs: {
        num1: null,
        num2: null,
        num3: null,
        num4: null,
        num5: null,
      },
      inputsCheck: [],
      weightStr: {},
      courseType: '', //课程类型
    }
  },
  watch: {
    'form.data.capabilityWeight'(now) {
      if (!now) {
        ;(this.inputs = {
          num1: null,
          num2: null,
          num3: null,
          num4: null,
          num5: null,
        }),
          (this.form.data.capabilityWeight = false)
        this.form.check = false
      } else {
        this.$refs.formCourse.validateField('capabilityWeight')
        // this.form.check = true
      }
    },
  },
  computed: {
    formRules() {
      return {
        icon: [{ required: true, message: '请选择课程封面', trigger: 'blur' }],
        name: [
          { required: true, message: '请输入课程名称', trigger: 'blur' },
          {
            validator: (_, value, callback) => {
              if (String(value).length > 15) {
                return callback(new Error('课程名称长度不能超过15字符'))
              }
              const reg = /[\/:*?"<>|.]/
              if (reg.test(value)) {
                return callback(new Error('课程名称不能包含特殊字符：/:*?"<>|.'))
              }
              callback()
            },
          },
        ],
        courseType: [{ required: true, message: '请选择课程类型', trigger: 'change' }],
        price: [{ required: true, message: '请输入课程价格', trigger: 'blur' }],
        period: [{ required: true, message: '请选择适用学段', trigger: 'change' }],
        minAge: [{ required: true, message: '请输入最小年龄', trigger: 'change' }],
        maxAge: [
          { required: true, message: '请输入最大年龄', trigger: 'change' },
          { min: this.form.data.minAge, max: 99, type: 'number', message: '不能小于最小年龄', trigger: 'blur' },
        ],
        courseAbilityList: [{ required: true, type: 'array', message: '请选择能力标签', trigger: 'change' }],
        suitAbilityType: [{ required: true, message: '请选择能力类型', trigger: 'change' }],
        capabilityWeight: [{ required: true, message: '请输入能力权重', trigger: 'change' }],
        normTag: [{ required: true, message: '请选择适用人群', trigger: 'change' }],
      }
    },
  },
  mounted() {
    this.nameEditor = new E('#nameEditor')
    this.nameEditor.config.height = 200
    this.nameEditor.create()
    this.remarkEditor = new E('#remarkEditor')
    this.remarkEditor.config.height = 150
    this.remarkEditor.create()
    if (this.$store.getters['course/getSeriesInfo']().status === 1) {
      this.nameEditor.disable()
      this.remarkEditor.disable()
    }
    this.initData()
    this.getAbilitySelect()
    this.GetBasicAbilities()
  },
  methods: {
    async getModeNorms() {
      const { data } = await this.$http.Base.getModelByKey({ key: 'NormTag' })
      if (data.enabled) {
        this.NormTags = JSON.parse(data.value)
      }
    },
    findAbilitTag(target, ids, result = []) {
      try {
        target.forEach((item) => {
          if (ids.includes(item.id)) {
            result.push(item)
          }
          if (item.children) {
            result.push(...this.findAbilitTag(item.children, ids))
          }
        })
        return result
      } catch (error) {
        console.log(error)
        return result
      }
    },
    capabilityWeightBlur() {
      if (this.form.data.capabilityWeight) {
        this.inputsCheck = Object.values(this.inputs).map((m) => typeof m !== 'number' || m < 0)
      }
    },
    GetBasicAbilities() {
      this.$http.Course.GetBasicAbilities().then((res) => {
        this.weightStr = res.data
      })
    },
    initData() {
      const data = this.$store.getters['course/getCourseInfo']()
      if (data) {
        this.baseSetLoading = true
        this.$http.CourseResource.courseDetail(data.id)
          .then((res) => {
            const { data } = res
            this.courseInfo = data
            for (let key in this.form.data) {
              this.form.data[key] = data[key]
            }
            if (data.courseAbilityWeights && data.courseAbilityWeights.length) {
              this.form.data.capabilityWeight = data.courseAbilityWeights.length > 0 ? true : false
              const courseAbilityWeights = data.courseAbilityWeights
              this.inputs.num1 = courseAbilityWeights[0]?.weight
              this.inputs.num2 = courseAbilityWeights[1]?.weight
              this.inputs.num3 = courseAbilityWeights[2]?.weight
              this.inputs.num4 = courseAbilityWeights[3]?.weight
              this.inputs.num5 = courseAbilityWeights[4]?.weight
            }
            this.form.data.period = data.period || undefined
            this.form.data.courseAbilityList = data.abilityTags
            this.form.data.introduce = undefined
            this.form.data.suitAbilityType = data.suitAbilityType || undefined
            this.nameEditor.txt.html(data.introduce)
            this.remarkEditor.txt.html(data.remark)
          })
          .finally(() => {
            this.baseSetLoading = false
          })
      }
    },
    changeIcon(info) {
      if (info.fileList[0].response) {
        this.form.data.icon = info.fileList[0].response.data
      }
      if (info.file.status === 'uploading') {
        this.iconloading = true
        this.imgLoading = true
        return
      }
      if (info.file.status === 'done') {
        getBase64(info.file.originFileObj, (imageUrl) => {
          this.form.data.icon = info.file.response.data
          this.iconloading = false
          this.imgLoading = false
          this.$refs.formCourse.validateField('icon')
        })
      }
    },
    beforeIcon(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJpgOrPng) {
        this.$message.error('请上传jpg或者png图片!')
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('图片大小不能超过2M!')
      }
      return isJpgOrPng && isLt2M
    },
    onSubmitAll() {
      this.form.data.introduce = this.nameEditor.txt.html()
      this.form.data.remark = this.remarkEditor.txt.html()
      if (this.form.data.capabilityWeight) {
        this.inputsCheck = Object.values(this.inputs).map((m) => typeof m !== 'number' || m < 0)
      } else {
        this.inputsCheck = []
      }
      this.$refs.formCourse.validate((valid) => {
        if (valid && !this.inputsCheck.includes(true)) {
          let capabilityWeight = []
          if (!this.form.data.capabilityWeight) {
            capabilityWeight = []
          } else {
            let str1 = {
              name: this.weightStr.attentionAbility.name,
              abilityId: this.weightStr.attentionAbility.id,
              weight: this.inputs.num1,
            }
            let str2 = {
              name: this.weightStr.memoryAbility.name,
              abilityId: this.weightStr.memoryAbility.id,
              weight: this.inputs.num2,
            }
            let str3 = {
              name: this.weightStr.reactionAbility.name,
              abilityId: this.weightStr.reactionAbility.id,
              weight: this.inputs.num3,
            }
            let str4 = {
              name: this.weightStr.selfAbility.name,
              abilityId: this.weightStr.selfAbility.id,
              weight: this.inputs.num4,
            }
            let str5 = {
              name: this.weightStr.thinkingAbility.name,
              abilityId: this.weightStr.thinkingAbility.id,
              weight: this.inputs.num5,
            }
            capabilityWeight.push(str1)
            capabilityWeight.push(str2)
            capabilityWeight.push(str3)
            capabilityWeight.push(str4)
            capabilityWeight.push(str5)
          }

          const ajax = this.form.data.id ? this.$http.CourseResource.courseUpdate : this.$http.CourseResource.courseAdd

          const json = {
            ...this.form.data,
            courseAbilityWeight: capabilityWeight,
            courseSeriesId: this.seriesInfo.id,
            courseAbilityList: undefined,
            abilityTags: this.form.data.courseAbilityList,
            baseLikeCount: this.form.data.baseLikeCount || 0,
            baseStudyCount: this.form.data.baseStudyCount || 0,
          }
          this.subLoading = true
          ajax(json)
            .then((res) => {
              this.$message.success(res.message)
              this.$store.dispatch('course/setCourseStatus')
              this.$router.push('/course/manage?type=3')
            })
            .finally(() => {
              this.subLoading = false
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 推荐配置
    getAbilitySelect() {
      let params = {
        isSelect: true,
        abilityType: 0,
      }
      this.$http.courseAbilitySelect(params).then((res) => {
        this.abilitySelect = res.data.data
      })
    },
  },
}
</script>

<style scoped lang="less">
.baseSet {
  width: 100%;

  h1 {
    font-size: 20px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
  }

  .card {
    margin-bottom: 24px;
  }

  #nameEditor,
  #remarkEditor {
    z-index: 1;
    position: relative;
  }
}

.ant-upload-picture-card-wrapper {
  display: block;
}

/deep/ .ant-upload.ant-upload-select-picture-card {
  width: 240px;
  height: 240px;
  margin: 0;
}

.age {
  display: flex;

  .ant-row.ant-form-item {
    width: 40%;
    margin: 0;
  }
}

.ant-input-number {
  width: 100%;
}

.self-item {
  width: 100%;
  display: flex;
}

.self-item-left {
  width: 460px;
  flex-shrink: 0;
}

.self-item-right {
  max-width: 700px;
  padding-left: 10px;
  flex-grow: 1;
}

.input-number {
  font-size: 13px;
  color: #bbb;
}

.input-textarea {
  resize: none;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.input-textarea-number {
  position: absolute;
  bottom: 0;
  right: 11px;
  font-size: 13px;
  color: #bbb;
}

.courseAbilityList /deep/ .ant-select-tree-node-selected:after {
  content: '\2713';
  float: right;
  margin-right: 10px;
}

.weight /deep/ .ant-form-item-control-wrapper {
  margin-top: 7px;
}

/deep/ .ant-input-number {
  width: 60%;
}

.weight {
  /deep/ .ant-form-item-children {
    display: flex;
    // align-items: center;
    position: relative;

    .inputs {
      flex: 1;
      margin-left: 20px;
      display: flex;
      flex-wrap: wrap;
      margin-top: -7px;
      margin-bottom: 0;

      li {
        height: 65px;
      }

      p {
        margin: 0;
        line-height: 20px;
        color: red;
      }

      .list {
        display: flex;
        align-items: center;
        // justify-content: space-between;
        // width:19%;
        margin-right: 20px;

        span {
          //display: inline-block;
          margin-right: 15px;
          // width:60px;
        }
      }
    }

    .errMsg {
      font-size: 12px;
      color: #f5222f;
      font-style: normal;
      position: absolute;
      bottom: -30px;
    }
  }
}

.form-like {
  display: flex;
  width: 100%;
  padding-left: 7.5%;

  .ant-form-item {
    width: 30%;
    min-width: 350px;
    display: flex;
  }
  .ant-input {
    width: fit-content;
  }
}
</style>
